// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ncSu","bigColWidth":"Table_bigColWidth__22vVS","biggerColWidth":"Table_biggerColWidth__3OJM-","row":"Table_row__1I_iA","col":"Table_col__3jXwH"};